function addSpansToClasses(classNames) {
    // Function to wrap text within brackets in a span with class 'nl-br'
    function wrapInSpan(text) {
      return text.replace(/\[(.*?)\]/g, '<span class="nl-br">[$1]</span>');
    }

    return new Promise((resolve) => {
        classNames.forEach((classNameObj, index) => {
            const selector = classNameObj.withChildAnchor ? `${classNameObj.name} ${classNameObj.targetElement != null ? classNameObj.targetElement : ''}` : `.${classNameObj.name}`;
            
            const elements = document.querySelectorAll(selector);

            elements.forEach(element => {
                const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);

                const textNodes = [];

                let node;
                while (node = walker.nextNode()) {
                    textNodes.push(node);
                }

                textNodes.forEach(textNode => {
                    const newText = wrapInSpan(textNode.nodeValue);
                    if (newText !== textNode.nodeValue) {
                        const span = document.createElement('span');
                        span.innerHTML = newText;
                        textNode.parentNode.replaceChild(span, textNode);
                    }
                });
            });

            // Resolve the promise when the last element is processed
            if (index === classNames.length - 1) {
                resolve();
            }
        });
    });
}

const loadMoreProducts = (collection, collectionProducts) => {
  if (document.getElementById('pagination-load-more')){    
    let loadMoreButton = document.getElementById('pagination-load-more');
    let productCountSpan = document.getElementById('pagination-product-count');
    let totalProducts = collection.products_count;
    let displayedProducts = collectionProducts.length;

    if (loadMoreButton) {      
        loadMoreButton.addEventListener('click', function() {          
            const currentPage = parseInt(loadMoreButton.getAttribute('data-current-page'));
            const totalPages = parseInt(loadMoreButton.getAttribute('data-total-pages'));
            const nextPage = currentPage + 1;

            if (nextPage <= totalPages) {
                fetch(`?page=${nextPage}`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                })
                .then(response => response.text())
                .then(data => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(data, 'text/html');
                    const newProducts = doc.querySelectorAll('#product-grid .grid__item');
                    const productGrid = document.getElementById('product-grid');

                    newProducts.forEach(product => {
                        productGrid.appendChild(product);
                    });

                    displayedProducts += newProducts.length;
                    productCountSpan.textContent = displayedProducts;
                    loadMoreButton.setAttribute('data-current-page', nextPage);

                    if (nextPage >= totalPages) {
                        loadMoreButton.style.display = 'none';
                    }
                })
                .catch(error => console.error('Error loading more products:', error));
            }
        });
    } 
  }  
}

// Example of how to call the function
window.onload = () => {
  addSpansToClasses([
    { name: 'card__heading', withChildAnchor: false, targetElement: null },
    { name: 'product__title', withChildAnchor: false, targetElement: null },
    { name: 'full-unstyled-link', withChildAnchor: true, targetElement: 'span' },
    { name: 'related-product-unstyled', withChildAnchor: false, targetElement: null }
  ]).then(() => {
    // Add the 'show-content' class once addSpansToClasses is complete    
    if( document.querySelector('.product .product__info-wrapper') ){
      document.querySelector('.product .product__info-wrapper').classList.add('show-content');
    }
    
  });
  if (document.getElementById('pagination-load-more')){
    let loadMoreBtn = document.getElementById('pagination-load-more');
    loadMoreBtn.addEventListener('click', (e) => {
      setTimeout(() => {
        addSpansToClasses([
          { name: 'card__heading', withChildAnchor: false, targetElement: null },        
          { name: 'full-unstyled-link', withChildAnchor: true, targetElement: 'span' }
        ]).then(() => {          
        });
      }, 500)      
    })
  }
  
};
